module.exports = __webpack_public_path__ + "img/16-meren-aalloissa.19881cae.jpg";